<script>
  import { Icon, CommandLine } from "svelte-hero-icons";
  import ImagePreview from "$lib/Elements/ImagePreview.svelte";
  import { imageManager } from "$lib/shared_stores";
  import { jobs } from "../store";

  export let logs = [];

  function getLevelStyle(level) {
    switch (level) {
      case "warning":
        return { text: "text-amber-400", label: "warn" };
      case "error":
        return { text: "text-red-400", label: "err " };
      default:
        return { text: "text-emerald-400", label: "info" };
    }
  }
</script>

<div class="px-4 py-2 flex items-center gap-2 border-b border-white/5 select-none">
  <div class="relative w-1.5 h-1.5 shrink-0">
    <div class="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-60"></div>
    <div class="relative w-1.5 h-1.5 rounded-full bg-emerald-400"></div>
  </div>
  <Icon src={CommandLine} class="w-3 h-3 text-content-subtle" />
  <span class="font-bold text-xs">print</span>
</div>

<div class="divide-y divide-white/5 max-h-40 overflow-y-auto">
  {#each logs as log}
    {@const levelStyle = getLevelStyle(log.data?.level)}
    {#if log.type === "log"}
      <div class="flex items-start gap-2.5 px-4 py-1.5 hover:bg-white/5 ml-2">
        <span class="shrink-0 {levelStyle.text} w-7 text-right tabular-nums opacity-80">
          {levelStyle.label}
        </span>
        <span class="text-content-muted shrink-0 select-none">&rsaquo;</span>
        <span class="text-gray-200 whitespace-pre-wrap break-all flex-1">{log.data.message}</span>
      </div>
    {:else if log.type === "log_image"}
      <div class="px-4 py-2 space-y-1.5 ml-2">
        <div class="flex items-center gap-2.5">
          <span class="text-purple-400 w-7 text-right shrink-0">img</span>
          <span class="text-content-muted select-none">&rsaquo;</span>
          {#if log.data.label}
            <span class="text-content-subtle">{log.data.label}</span>
          {/if}
        </div>
        <div class="ml-[3.125rem]">
          <ImagePreview
            src={imageManager.src(log.data.url)}
            alt={log.data.label || "log image"}
            class="max-w-full h-auto rounded"
            sessionId={$jobs.m3u8}
          />
        </div>
      </div>
    {/if}
  {/each}
</div>
